import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ChangeEmployerRequestModel } from '../../../model/changeEmployerRequestModel';
import { ChangeEmployerResponseModel } from '../../../model/changeEmployerResponseModel';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { ChangeEmployerService } from '../change-employer.service';
import { Router } from '@angular/router';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { MessageModel } from '../../../model/models';
import * as $ from 'jquery';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { TransactionsService } from '../../../transactions/transactions.service';
import { Subscription } from 'rxjs';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { StorageService } from '../../../shared/security/StorageService';


@Component({
  selector: 'app-select-new-employer',
  templateUrl: './select-new-employer.component.html',
  styleUrls: ['./select-new-employer.component.css']
})
export class SelectNewEmployerComponent implements OnInit, OnDestroy {

  submitted: boolean = false;
  employerNumber: string;
  workflow: WorkflowModel = new WorkflowModel();
  changeEmployerRequest: ChangeEmployerRequestModel;
  changeEmployerResponse: ChangeEmployerResponseModel;
  employmentInfo: EntityLicenseModel;
  agree: boolean;
  employmentInfoSubscription: Subscription;
  employerChangeAgreementSubsription: Subscription;
  startFunction: StartFunctionResponseModel;
  userMessages: Array<MessageModel> = [];

  constructor(private changeEmployerService: ChangeEmployerService,
    private router: Router,
    private startFunctionService: StartFunctionService,
    private currentPageWatcherService: CurrentPageWatcherService,
    private spinner: SpinnerService,
    private storageService: StorageService) {
    this.startFunction = this.storageService.getStartFunctionData();
     if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {

    //   this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
       this.workflow = this.startFunction.Workflow;
    //   console.log("In SELECT NEW EMPLOYER : " + this.startFunction.Workflow.Steps[2].StepDisplayName);
     }
    this.employmentInfoSubscription = this.changeEmployerService.getNotifyEmploymentInformation().subscribe(data => {
      this.employmentInfo = data;
      console.log("Employment Info : " + this.employmentInfo);
    });



    this.employerChangeAgreementSubsription = this.changeEmployerService.getNotifyAgreement().subscribe(data => {
      this.agree = data;
      console.log("Agree : " + this.agree);
    });
  }

  ngOnInit() {
    this.submitted = false;
  }

  changeEmployer(selectEmployerForm) {
    this.currentPageWatcherService.sendUserMessages(null);
    this.submitted = true;
    if (selectEmployerForm.valid) {
      this.changeEmployerRequest = new ChangeEmployerRequestModel();
      this.changeEmployerRequest.WorkflowID = this.workflow.WorkflowID;
      this.changeEmployerRequest.NewEmployerLicenseNumber = this.employerNumber;
      this.changeEmployerRequest.CurrentStepIndex = this.workflow.CurrentStepIndex;


      this.changeEmployerService.postChangeEmployer(this.changeEmployerRequest).subscribe(changeEmployerResp => {
        this.changeEmployerResponse = changeEmployerResp;
        console.log("Change Employer - Select Employer:  ", changeEmployerResp);
        //
        if (changeEmployerResp.UserMessages != undefined) {

          changeEmployerResp.UserMessages.forEach(el => {
              this.userMessages.push(el);
          });
        }
        //no error
        console.log("this.userMessages : ",this.userMessages);
        this.currentPageWatcherService.sendUserMessages(this.userMessages);
        if (changeEmployerResp.Summary == 0){
          this.router.navigate(['/reviewEmployerChange']).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);
            this.changeEmployerService.getNotifySelectedEmployer().emit(changeEmployerResp);
            this.changeEmployerService.getNotifyAgreement().emit(this.agree);
            this.changeEmployerService.getNotifyEmploymentInformation().emit(this.employmentInfo);
          });
          this.userMessages = [];
        }
        if (changeEmployerResp.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (changeEmployerResp.Summary == 2){
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }
      },
        (err) => {
          if (err.error && err.error.UserMessages != undefined) {
            err.error.UserMessages.forEach(element => {
              this.userMessages.push(element)
            });

          }
          else {
            let userMsg: MessageModel;
            userMsg.Alert = 3;
            userMsg.Description = err.message;
            this.userMessages.push(userMsg);

          }
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.currentPageWatcherService.sendUserMessages(this.userMessages);
          this.spinner.hide();
        });
    }
  }



  ngOnDestroy(): void {
    //this.currentPageWatcherService.clearUserMessage();
    // this.employerChangeAgreementSubsription.unsubscribe();
    // this.employmentInfoSubscription.unsubscribe();
    this.currentPageWatcherService.clearUserMessage();
    this.currentPageWatcherService.clearStepMessage();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.currentPageWatcherService.sendUserMessages(null);
    this.startFunctionService.getNotifyStepInProgress().emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/change-employer/select-new-employer/select-new-employer.component.ts